var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28755 3.05102L7.8838 5.0981C7.7988 5.51602 7.91214 5.9481 8.1813 6.27393C8.45047 6.59977 8.84714 6.79102 9.27214 6.79102H13.168V7.55602L11.3476 11.7493H5.61714C5.48964 11.7493 5.3763 11.636 5.3763 11.5085V5.95518L8.28755 3.05102ZM8.91797 0.416016L4.37755 4.95643C4.10839 5.2256 3.95964 5.58685 3.95964 5.96227V11.5085C3.95964 12.4223 4.70339 13.166 5.61714 13.166H11.3546C11.8576 13.166 12.318 12.9039 12.573 12.4789L14.4642 8.12268C14.5421 7.9456 14.5846 7.75435 14.5846 7.55602V6.79102C14.5846 6.01185 13.9471 5.37435 13.168 5.37435H9.27214L9.9238 2.0806C9.95922 1.92477 9.93797 1.75477 9.86714 1.6131C9.70422 1.29435 9.4988 1.00393 9.2438 0.748932L8.91797 0.416016ZM1.83464 5.37435H0.417969V13.166H1.83464C2.22422 13.166 2.54297 12.8473 2.54297 12.4577V6.08268C2.54297 5.6931 2.22422 5.37435 1.83464 5.37435Z",
    fill: "#D56D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.258ebeed.svg";
export { ForwardRef as ReactComponent };